const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    // Mantém também o caminho legado .html para não quebrar links externos
    path: ["/privacidade", "/privacidade.html"],
    exact: true,
    component: "Privacy",
  },
  {
    path: ["/termos", "/termos.html"],
    exact: true,
    component: "Terms",
  },
  {
    path: ["/exclusao", "/exclusao.html"],
    exact: true,
    component: "DataDeletion",
  },
  {
    path: ["/seguranca", "/seguranca.html"],
    exact: true,
    component: "Security",
  },
];

export default routes;
